export const flowTeamHallZH = {
  flowTeamHall1: '组队大厅',
  flowTeamHall2: '不想当队长？来此加入队伍',
  flowTeamHall3: '找不到队员？来此邀请队员',
  flowTeamHall4: '找不到队友？前往',
  flowTeamHall5: '仅展示未完成组队的队伍或未组队的成员',
  flowTeamHall6: '搜索团队（团队名称）',
  flowTeamHall7: '我的团队',
  flowTeamHall8: '加入队伍',
  flowTeamHall9: '寻找队员',
  flowTeamHall10: '选择组别',
  flowTeamHall11: '选择城市',
  flowTeamHall12: '搜索学校 ',
  flowTeamHall13: '我要找队员 ',
  flowTeamHall14: '团队学校',
  flowTeamHall15: '学校城市',
  flowTeamHall16: '团队组别',
  flowTeamHall17: '团队背景',
  flowTeamHall18: '期望队友特征',
  flowTeamHall19: '查看全部',
  flowTeamHall20: '人',
  flowTeamHall21: '编辑信息',
  flowTeamHall22: '申请中',
  flowTeamHall23: '申请加入',
  flowTeamHall24: '学校',
  flowTeamHall25: '组别',
  flowTeamHall26: '年级',
  flowTeamHall27: '个人背景',
  flowTeamHall28: '期望队伍特征',
  flowTeamHall29: '搜索成员（报名手机号）',
  flowTeamHall30: '邀请中',
  flowTeamHall31: '邀请入队',
  flowTeamHall32: '你当前并未在队伍中，若需要发布队伍招募信息，请创建队伍。',
  flowTeamHall33: '创建团队',
  flowTeamHall34: '你当前已经在队伍中，无法申请加入其他队伍，如若需要，请退出队伍后再申请。',
  flowTeamHall35: '你当前并未在队伍中，若需要邀请成员入队，请创建队伍。',
  flowTeamHall36: '当前活动季组队任务已结束，组队大厅已关闭',
  flowTeamHall37: '分享',
  flowTeamHall38: '团队成员的能力描述、过往成就、成绩及队内氛围……',
  flowTeamHall39: '期望队员的能力、性格等特征……',
  flowTeamHall40: '团队联系方式',
  flowTeamHall41: '仅在邀请成员时，展示团队联系方式给邀请的成员',
  flowTeamHall42: '请填写团队联系方式',
  flowTeamHall43: '个人能力描述、过往成就、成绩及性格特征……',
  flowTeamHall44: '期望加入团队的能力、成就和队伍氛围……',
  flowTeamHall45: '我的联系方式',
  flowTeamHall46: '仅在申请入队时，展示个人联系方式给申请的队伍',
  flowTeamHall47: '请填写我的联系方式',
  flowTeamHall48: '请填写团队背景',
  flowTeamHall49: '请填写期望队友特征',
  flowTeamHall50: '请填写团队联系方式',
  flowTeamHall51: '请填写个人背景',
  flowTeamHall52: '请填写期望队伍特征',
  flowTeamHall53: '请填个人联系方式',
  flowTeamHall54: '申请加入',
  flowTeamHall55: '是否申请加入队伍',
  flowTeamHall56: '申请后队伍将可获得你的联系方式。',
  flowTeamHall57: '你还未配置我要找队伍信息，可点此',
  flowTeamHall58: '请输入你的联系方式 ',
  flowTeamHall59: '邀请入队',
  flowTeamHall60: '是否邀请',
  flowTeamHall61: '加入队伍？被邀请的成员将获得队伍联系方式。',
  flowTeamHall62: '队伍还未配置找队员信息，无法邀请成员，请填写找队员信息',
  flowTeamHall63: '前往配置 ',
  flowTeamHall64: '已拒绝',
  flowTeamHall65: '已接受',
  flowTeamHall66: '全部筛选',
  flowTeamHall67: '筛选',
  flowTeamHall68: '清空选择',
  flowTeamHall69: '组别',
  flowTeamHall70: '城市',
  flowTeamHall71: '学校',
  flowTeamHall72: '我要找队伍',
  flowTeamHall73: '保存',
  flowTeamHall74: '请填写团队名称',
  flowTeamHall75: '团队信息',
  flowTeamHall76: '，若暂不配置，请填写你的联系方式：',
  flowTeamHall77: '确认',
  flowTeamHall78: '暂时没有数据',
  flowTeamHall79: '取消',
  flowTeamHall80: '加载中',
  flowTeamHall81: '申请成功!',
  flowTeamHall82: '邀请成功!',
  flowTeamHall83: '名称',
  flowTeamHall84: '无匹配学校',
  flowTeamHall85: '确定',
  flowTeamHall86: '团队信息',
  flowTeamHall87: '个人信息',
  flowTeamHall88: '手机号',
  flowTeamHall90: '查看队友信息',
  flowTeamHall91: '联系电话',
  flowTeamHall92: '电子邮箱',
  flowTeamHall93: '队友信息',
  flowTeamHall94: '团队身份',
  flowTeamHall95: '用户',
  flowTeamHall96: '队员'
}

export const flowTeamHallEN = {
  flowTeamHall1: 'Team Lobby',
  flowTeamHall2: 'Don\'t want to lead? Join a team here',
  flowTeamHall3: 'Can\'t find members? Invite players here',
  flowTeamHall4: 'Can\'t find a teammate? Go to ',
  flowTeamHall5: 'Showing only incomplete teams or unteamed members',
  flowTeamHall6: 'Search Teams by Name',
  flowTeamHall7: ' My Team',
  flowTeamHall8: 'Join Team',
  flowTeamHall9: 'Find Members',
  flowTeamHall10: 'Select Division',
  flowTeamHall11: 'Select City',
  flowTeamHall12: 'Search School ',
  flowTeamHall13: ' I Want to Find Members',
  flowTeamHall14: 'Team School',
  flowTeamHall15: 'School City',
  flowTeamHall16: 'Team Division',
  flowTeamHall17: ' Team Background',
  flowTeamHall18: 'Desired Teammate Qualities',
  flowTeamHall19: 'View All',
  flowTeamHall20: 'Members',
  flowTeamHall21: 'Edit Info',
  flowTeamHall22: 'Pending',
  flowTeamHall23: 'Request to Join',
  flowTeamHall24: 'School',
  flowTeamHall25: 'Division',
  flowTeamHall26: 'Grade',
  flowTeamHall27: 'Personal Background',
  flowTeamHall28: 'Desired Team Qualities',
  flowTeamHall29: 'Search Members by Phone',
  flowTeamHall30: 'Inviting',
  flowTeamHall31: 'Invite',
  flowTeamHall32: 'You are not currently in a team. To post a recruitment, please create a team.',
  flowTeamHall33: 'Create Team',
  flowTeamHall34: 'You are already in a team and cannot apply to others. If needed, please leave your current team first.',
  flowTeamHall35: 'You are not currently in a team. To invite members, please create a team.',
  flowTeamHall36: 'The team formation task for the current season has ended. The Team Lobby is now closed.',
  flowTeamHall37: 'Share',
  flowTeamHall38: 'Team members\' skills, past achievements, results, team atmosphere...',
  flowTeamHall39: 'Desired member skills, personality, etc...',
  flowTeamHall40: 'Team Contact Info',
  flowTeamHall41: 'Team contact info is only shown to invited members.',
  flowTeamHall42: 'Please provide team contact information.',
  flowTeamHall43: 'Personal skills, past achievements, results, and personality...',
  flowTeamHall44: 'Desired team skills, achievements, and atmosphere...',
  flowTeamHall45: 'My Contact Info',
  flowTeamHall46: 'My contact info is only shown to teams I apply to.',
  flowTeamHall47: 'Please provide my contact information.',
  flowTeamHall48: 'Please describe your team background.',
  flowTeamHall49: 'Please describe your desired teammate qualities.',
  flowTeamHall50: 'Please provide your team contact information.',
  flowTeamHall51: 'Please describe your personal background.',
  flowTeamHall52: 'Please describe your desired team qualities.',
  flowTeamHall53: 'Please provide your personal contact information.',
  flowTeamHall54: 'Apply',
  flowTeamHall55: 'Apply to join team',
  flowTeamHall56: 'The team will get your contact info upon application.',
  flowTeamHall57: 'You haven\'t set up your "Find a Team" profile. You can set it up',
  flowTeamHall58: 'Please enter your contact information.',
  flowTeamHall59: 'Invite',
  flowTeamHall60: 'Invite',
  flowTeamHall61: 'to join the team? The invited member will receive the team\'s contact info.',
  flowTeamHall62: 'Your team hasn\'t set up its "Find Members" profile and cannot invite members. Please complete the profile.',
  flowTeamHall63: 'Set Up Now',
  flowTeamHall64: 'Declined',
  flowTeamHall65: 'Accepted',
  flowTeamHall66: 'See All',
  flowTeamHall67: 'Filter',
  flowTeamHall68: 'Clear All',
  flowTeamHall69: 'Division',
  flowTeamHall70: 'City',
  flowTeamHall71: 'School',
  flowTeamHall72: 'Find a Team',
  flowTeamHall73: 'Save',
  flowTeamHall74: 'Please fill in the team name',
  flowTeamHall75: 'Team Information',
  flowTeamHall76: ', or provide your contact info for now:',
  flowTeamHall77: 'Confirm',
  flowTeamHall78: 'No Data Yet',
  flowTeamHall79: 'Cancel',
  flowTeamHall80: 'Loading',
  flowTeamHall81: 'Application successful!',
  flowTeamHall82: 'Invitation successful!',
  flowTeamHall83: 'Name',
  flowTeamHall84: 'No matching schools',
  flowTeamHall85: 'Confirm',
  flowTeamHall86: 'Personal Information',
  flowTeamHall87: 'Team Information',
  flowTeamHall88: 'Phone',
  flowTeamHall90: 'View Teammates\' Info',
  flowTeamHall91: 'Contact Number',
  flowTeamHall92: 'Email',
  flowTeamHall93: 'Teammate Information',
  flowTeamHall94: 'Team Role',
  flowTeamHall95: 'User',
  flowTeamHall96: 'Team Member'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/teamFormationHall.js